module.exports = __webpack_public_path__ + "img/sample-photo-1.b69b5afa.png";